module.exports = __webpack_public_path__ + "img/logo-white.ec658da0.svg";